var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-slider",
      class: { edit: _vm.isSelected },
      on: { click: _vm.finish },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
        on: { click: _vm.stickerInstance.nextColor },
      }),
      _c(
        "div",
        {
          staticClass: "sticker sticker-slider",
          class: [
            `color-${_vm.stickerInstance.data.color.slice(1).toUpperCase()}`,
          ],
          style: {
            backgroundColor: _vm.stickerInstance.data.color,
          },
        },
        [
          _vm.isSelected || _vm.stickerInstance.data.question
            ? _c("div", { staticClass: "slider-header" }, [
                _c("textarea", {
                  ref: "textareaSlider",
                  attrs: {
                    cols: "20",
                    rows: "2",
                    wrap: "hard",
                    maxlength: "100",
                    placeholder: _vm.$t(
                      "dash.post-creator.story.survey-question"
                    ),
                    readonly: !_vm.isSelected,
                  },
                  domProps: { value: _vm.stickerInstance.data.question },
                  on: { input: _vm.resize },
                }),
              ])
            : _vm._e(),
          _c("div", { staticClass: "slider" }, [
            _c("span", { staticClass: "emoji" }, [
              _vm._v(_vm._s(_vm.stickerInstance.data.emoji)),
            ]),
            _c("div", { staticClass: "bar" }),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "list-emoji" },
        [
          _c(
            "carousel",
            {
              attrs: { perPage: 1, adjustableHeight: true, centerMode: true },
              on: { pageChange: () => {} },
            },
            _vm._l(
              [
                ["😍", "😂", "😀", "🔥", "😡", "😱", "😢", "🙌"],
                ["❤️", "🎉", "👍", "💩", "💯", "🙏", "😮", "add"],
              ],
              function (emojis, index) {
                return _c(
                  "Slide",
                  { key: index },
                  [
                    _vm._l(emojis, function (emo) {
                      return [
                        emo == "add"
                          ? _c(
                              "div",
                              {
                                staticClass: "add",
                                on: {
                                  click: function ($event) {
                                    _vm.displayEmojiPicker = true
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fa-regular fa-plus" })]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "emoji",
                                on: {
                                  click: function ($event) {
                                    _vm.stickerInstance.data.emoji = emo
                                  },
                                },
                              },
                              [_vm._v(_vm._s(emo))]
                            ),
                      ]
                    }),
                  ],
                  2
                )
              }
            ),
            1
          ),
        ],
        1
      ),
      _c("Picker", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSelected && _vm.displayEmojiPicker,
            expression: "isSelected && displayEmojiPicker",
          },
        ],
        ref: "emojiPicker",
        style: _vm.pickerStyle,
        attrs: {
          data: _vm.emojiIndex,
          i18n: {
            search: _vm.$t("dash.post-creator.story.emoji-search"),
            notfound: _vm.$t("dash.post-creator.story.emoji-not-found"),
            categories: {
              search: _vm.$t("dash.post-creator.story.emoji-cat-search"),
              recent: _vm.$t("dash.post-creator.story.emoji-cat-recent"),
              smileys: _vm.$t("dash.post-creator.story.emoji-cat-smileys"),
              people: _vm.$t("dash.post-creator.story.emoji-cat-people"),
              nature: _vm.$t("dash.post-creator.story.emoji-cat-nature"),
              foods: _vm.$t("dash.post-creator.story.emoji-cat-foods"),
              activity: _vm.$t("dash.post-creator.story.emoji-cat-activity"),
              places: _vm.$t("dash.post-creator.story.emoji-cat-places"),
              objects: _vm.$t("dash.post-creator.story.emoji-cat-objects"),
              symbols: _vm.$t("dash.post-creator.story.emoji-cat-symbols"),
              flags: _vm.$t("dash.post-creator.story.emoji-cat-flags"),
              custom: _vm.$t("dash.post-creator.story.emoji-cat-custom"),
            },
          },
          color: "#b64985",
        },
        on: { select: _vm.addEmoji },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }